import { getFieldAreaBySeason } from 'utils/getGeometryBySeason';

const checkIsBorderlessField = (field, season) => {
  if (season != null && field?.geometries?.length) {
    return !getFieldAreaBySeason(field, season);
  }
  return !field?.area;
};

export default checkIsBorderlessField;
